import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import Heading from 'components/Heading';
import Button from 'components/Button';
import { FileViewer } from 'libs/rendering';

import { Center } from 'legacyComponents/styled/lib';
import {
  ConflictColumn,
  ActionWrapper,
  LocalFileHeader,
  ViewerWrapper,
  Status,
  NoFile,
  IconStyled,
} from 'apps/project/tabs/conflicts/styles';

export const LocalConflict = withNamespaces()(
  observer(({ conflicts, activeConflict, manager }) => {
    if (!conflicts || conflicts.length === 0) {
      return <ConflictColumn last />;
    }
    const conflict = conflicts.apps[activeConflict];
    const header = (
      <LocalFileHeader active>
        <Heading level={3}>
          <Trans>Your local change</Trans>
        </Heading>
      </LocalFileHeader>
    );
    const removed = conflict.localStatus === 'REMOVED';
    const { localStatus, local } = conflict;
    const { SetResolution, resolution } = manager;

    const resolutionValue = removed ? null : local.id;
    const isResolution =
      Object.keys(resolution.toJS()).includes(conflict.path) &&
      resolution.get(conflict.path) === resolutionValue;

    return (
      <ConflictColumn last>
        {header}
        <ViewerWrapper>
          <Status red={removed}>
            <Trans>{localStatus}</Trans>
          </Status>
          {isResolution && <IconStyled name='success' />}
          {removed ? (
            <Center>
              <NoFile>
                <Trans>This file was deleted</Trans>
              </NoFile>
            </Center>
          ) : (
            <FileViewer file={local} />
          )}
        </ViewerWrapper>
        <ActionWrapper>
          {isResolution ? null : (
            <Center>
              {removed ? (
                <Button
                  text={<Trans>Delete file</Trans>}
                  variant='destructive'
                  size='small'
                  onClick={() =>
                    SetResolution('delete', conflict, null, activeConflict)
                  }
                />
              ) : (
                <Button
                  text={<Trans>Pick file</Trans>}
                  size='small'
                  onClick={() =>
                    SetResolution('pick', conflict, local.id, activeConflict)
                  }
                  outline
                />
              )}
            </Center>
          )}
        </ActionWrapper>
      </ConflictColumn>
    );
  }),
);
